import templateStr from 'text!./activities-view.html';
import moment from 'moment';
import _ from 'underscore';
import JobUtil from 'edge/gateway/util/JobUtil';

export default ['$filter', 'ActivityService', 'ModalService', 'ViewModelService', 'InsuranceSuiteMetadata', function ($filter, ActivityService, ModalService, ViewModelService, InsuranceSuiteMetadata) {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            activities: '='
        },
        // replace: true,
        controller: ['$scope', '$q', 'GPA_PC_ENTRY_POINT', function ($scope, $q, GPA_PC_ENTRY_POINT) {
            var priorityTypelist = InsuranceSuiteMetadata.get('pc').types.getTypelist('Priority');

            $scope.note = {
                subject: '',
                body: ''
            };

            $scope.noteView = ViewModelService.create($scope.note, 'pc', 'edge.capabilities.gateway.note.dto.NoteDTO');

            $scope.jobUtil = JobUtil;

            $scope.openJobInXCenter = function (jobNumber) {
                JobUtil.openJobInXCenter(GPA_PC_ENTRY_POINT, jobNumber);
            };

            $scope.toggleAddNoteForm = function (activity) {
                resetNoteView();
                activity.addNoteFormVisible = angular.isDefined(activity.addNoteFormVisible) ? !activity.addNoteFormVisible : true;
            };

            $scope.saveNote = function (activity, form) {
                form.submitted = true;
                if (form.invalid) {
                    return;
                }
                var createActivityNotePromise = ActivityService.createNoteForActivity(activity.publicID, $scope.note);
                $scope.createActivityNotePromise = createActivityNotePromise;

                $q.when(createActivityNotePromise, function (createdNote) {
                    $scope.toggleAddNoteForm(activity);
                    ModalService.showInfo('gateway.directives.activity-schedule.Done', 'gateway.directives.activity-schedule.Note created');
                    activity.notes.push(createdNote);
                    activity.notes.sort(function (a, b) {
                        return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
                    });
                    $scope.$emit('noteAdded', activity.notes);
                    resetNoteView();
                }, function () {
                    ModalService.showError('gateway.directives.activity-schedule.Error', 'gateway.directives.activity-schedule.Failed to create note', '');
                });
            };
            /**
             * Calculate portal notes Count
             * 
             */
            $scope.portalNotesCount = function (allNotes) {
                var portalCount = 0;
                var x = allNotes;
                for (var i = 0; i < x.length; i++) {
                    if (x[i] != undefined && x[i].mSFIsNoteCreatedByCurrentUser_EXT == true) {
                        portalCount++;
                    }
                }
                return parseInt(portalCount);
            };

            function resetNoteView() {
                $scope.noteView.subject.value = '';
                $scope.noteView.topic.value = '';
                $scope.noteView.body.value = '';
            }

            $scope.toggleActivity = function (activity) {
                activity.expanded = angular.isDefined(activity.expanded) ? !activity.expanded : true;
            };

            $scope.sortNotes = function (activity) {
                return activity.notes.sort(function (a, b) {
                    return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
                });
            };

            $scope.showNotes = function (activity) {
                activity.showNotes = angular.isDefined(activity.showNotes) ? !activity.showNotes : true;
            };

            $scope.sortNotes = function (activity) {
                return activity.notes.sort(function (a, b) {
                    return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
                });
            };
            /**
             * Sorting only Portal Notes
             */
            $scope.sortPortalNotes = function (activity) {
                var portalNotes = activity.notes;
                angular.forEach(portalNotes, function (noteValue, noteKey) {
                    if (!noteValue || noteValue.mSFIsNoteCreatedByCurrentUser_EXT == undefined || noteValue.mSFIsNoteCreatedByCurrentUser_EXT != true) delete portalNotes[noteKey];
                });
                return portalNotes.sort(function (a, b) {
                    return new Date(b.createdDate).getTime() - new Date(a.createdDate).getTime();
                });
            };

            $scope.isOverdue = function (dueDate) {
                return moment(dueDate).isBefore(moment(), 'd');
            };

            $scope.isCompleted = function (status) {
                return status === 'complete';
            };

            $scope.noDueDateToTop = function (activity) {
                return angular.isDefined(activity.dueDate) ? 0 : -1;
            };

            $scope.competeActivity = function (anActivity) {
                var markActivityAsCompletedPromise = ActivityService.markActivityAsCompleted(anActivity.publicID);

                markActivityAsCompletedPromise.then(function (activity) {
                    anActivity.status = activity.status;
                    anActivity.closeDate = activity.closeDate;
                    anActivity.completedDate = activity.completedDate;
                    anActivity.expanded = false;
                    $scope.$emit('activityCompleted');
                    $scope.$emit('activitiesUpdated', _.where($scope.$parent.activities, { status: 'open' }));
                }, function () {
                    ModalService.showError('Error', 'Could not mark this Activity as complete.');
                });
            };

            $scope.getPriorityDisplayName = function (priority) {
                return priorityTypelist.getCode(priority).name;
            };
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/RefreshActivitiesViewDirective/ActivitiesView.js
// module id = 1763
// module chunks = 0